
export default (obj, formData = new FormData(), parentKey = null) => {
    function processObject(obj, formData, parentKey) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const value = obj[key];
                const currentKey = parentKey ? `${parentKey}[${key}]` : key;

                if (typeof value === "object" && !Array.isArray(value)) {
                    // Рекурсивный вызов для вложенных объектов
                    formData = processObject(value, formData, currentKey);
                } else if (Array.isArray(value)) {
                    // Добавление каждого элемента массива
                    value.forEach((item, index) => {
                        const arrayKey = `${currentKey}[${index}]`;
                        if (typeof item === "object" && !Array.isArray(item)) {
                            formData = processObject(item, formData, arrayKey);
                        } else {
                            formData.append(arrayKey, item);
                        }
                    });
                } else {
                    // Добавление значения как есть
                    formData.append(currentKey, value);
                }
            }
        }

        return formData;
    }
    return processObject(obj, formData, parentKey);
};
